<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Settings</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Payment Settings
        <button mat-raised-button style="background: green;color: white;margin-right: 10px;"
            (click)="Update_setting()"><mat-icon>save</mat-icon>Save</button>
    </div>
</div>
<div class="d-flex justify-content-center">
    <mat-card class="col-lg-9 col-sm-12">
        <mat-card-content>
            <div class="row ">

                <div class="adsimage">
                    <img src="https://aieventzo.com/upload/payment_logo/{{this.imagePath}}"
                        style="width: 100px;height: 100px;">
                </div>

                <div class="mb-5 mt-5">
                    <mat-label>Upload Image :</mat-label>
                    <input type="file" #file class="form-control" id="inputGroupFile02"
                        accept="image/png, image/jpeg, image/jpg " (change)="previewpimage(file.files)">
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Business Name</mat-label>
                    <input matInput [(ngModel)]="name" placeholder="Enter Your Business Name to Show in Payment Popup">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Razorpay Key</mat-label>
                    <input [(ngModel)]="razorpay_key" matInput placeholder="Enter Your Razorpay Key">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Razorpay Secret</mat-label>
                    <input [(ngModel)]="razorpay_secret" matInput placeholder="Enter Your Razorpay Secret">
                </mat-form-field>

                <div class="col-lg-10 col-7">
                    <mat-label>Payment Option:</mat-label>
                    <mat-radio-group [(ngModel)]="payment_option">
                        <mat-radio-button value="payment_gateway">Payment Gateway</mat-radio-button>
                        <mat-radio-button value="qrcode">QRcode</mat-radio-button>
                    </mat-radio-group>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>UPI ID</mat-label>
                    <input [(ngModel)]="upi_id" matInput placeholder="Enter Your Razorpay Secret">
                </mat-form-field>



            </div>
        </mat-card-content>
        <!-- <mat-card-actions align="end">
            <button mat-raised-button color="primary" (click)="Update_setting()">Save</button>
        </mat-card-actions> -->
    </mat-card>
</div>